import React, { useEffect, useMemo } from 'react';
import { inject, observer } from 'mobx-react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import { RootStore } from '@/models';
import s from './index.less';
import { Icon } from '@/components';

interface ModelState {
  simultaneous?: RootStore['simultaneousInterpretation'];
}

interface Props extends ModelState {
  back: () => void;
}

const SwitchChannel: React.FC<Props> = inject(({ store }) => {
  return {
    simultaneous: store.simultaneousInterpretation,
  };
})(
  observer((props) => {
    const { simultaneous, back } = props;
    const { curChannel, allChannels } = simultaneous || {};
    const { formatMessage } = useIntl();

    return (
      <div
        className={s.panel}
        onClick={(e) => {
          e.nativeEvent.stopImmediatePropagation();
        }}
      >
        <div className={s.block}>
          <div
            className={s.header}
            onClick={() => {
              back && back();
            }}
          >
            <Icon className={s.rightLeft} name="icon-a-16_outlined_left" />
            <div className={s.desc}>{formatMessage({ id: 'AUDIENCE_CHANNEL' })}</div>
          </div>
          <div className={s.line} />
          {allChannels?.map((item, index: number) => (
            <div
              key={index}
              className={s.item}
              onClick={() => {
                simultaneous?.setCurChannel(item.yxSubchannelName!, item.languageTag!);
                back && back();
              }}
            >
              {curChannel === item.yxSubchannelName ? (
                <Icon className={s.check} name="icon-check" />
              ) : (
                <span className={s.check} />
              )}
              {item.languageName}
            </div>
          ))}
        </div>
      </div>
    );
  })
);
export default SwitchChannel;
